import { User } from '@features/users/models/user';
import { Lookup } from '../../shared-features/models/Lookup.model';
import { Model } from '../../shared-features/models/model';
import { Expose } from 'class-transformer';
import { InvoiceReminderTimeframe } from '../enums/invoice-reminder-timeframe.enum';

export class CustomerEmailSettings extends Model {
  @Expose()
  customerId: number;

  @Expose()
  isShipmentCreationEmailEnabled: boolean;

  @Expose()
  isShipmentAssignedEmailEnabled: boolean;

  @Expose()
  isShipmentStartEmailEnabled: boolean;

  @Expose()
  isShipmentArrivedPickupLocationEmailEnabled: boolean;

  @Expose()
  isShipmentDeliveredEmailEnabled: boolean;

  @Expose()
  isShipmentLoadedEmailEnabled: boolean;

  @Expose()
  isShipmentArrivedDeliveryLocationEmailEnabled: boolean;

  // Toggle Buttons Value for Detailed Settings
  @Expose()
  isShipmentCreationBasicEmailEnabled: boolean;

  @Expose()
  isShipmentAssignedBasicEmailEnabled: boolean;

  @Expose()
  isShipmentStartBasicEmailEnabled: boolean;

  @Expose()
  isShipmentArrivedPickupLocationBasicEmailEnabled: boolean;

  @Expose()
  isShipmentDeliveredBasicEmailEnabled: boolean;

  @Expose()
  isShipmentLoadedBasicEmailEnabled: boolean;

  @Expose()
  isShipmentArrivedDeliveryLocationBasicEmailEnabled: boolean;

  @Expose()
  bcc: string[];

  @Expose()
  tempAlertTo: Lookup[];

  @Expose()
  tempAlertBcc: Lookup[];

  @Expose()
  isTempAlertEnabled: boolean;

  @Expose()
  isShipmentAssignedDriverIqamaAttachmentEmailEnabled: boolean;

  @Expose()
  isShipmentStartDriverIqamaAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentArrivedPickupLocationDriverIqamaAttachmentEmailEnabled: boolean;

  @Expose()
  isShipmentLoadedDriverIqamaAttachmentEmailEnabled: boolean;

  @Expose()
  isShipmentArrivedDeliveryLocationDriverIqamaAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentDeliveredDriverIqamaAttachmentEmailEnabled: boolean;

  @Expose()
  isShipmentAssignedDriverLicenseAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentStartDriverLicenseAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentArrivedPickupLocationDriverLicenseAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentLoadedDriverLicenseAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentArrivedDeliveryLocationDriverLicenseAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentDeliveredDriverLicenseAttachmentEmailEnabled: boolean;

  @Expose()
  isShipmentAssignedTruckLicenseAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentStartTruckLicenseAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentArrivedPickupLocationTruckLicenseAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentLoadedTruckLicenseAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentArrivedDeliveryLocationTruckLicenseAttachmentEmailEnabled: boolean;
  @Expose()
  isShipmentDeliveredTruckLicenseAttachmentEmailEnabled: boolean;

  @Expose()
  isShipmentCreationNotifiedList: string[];
  @Expose()
  isShipmentAssignedNotifiedList: string[];
  @Expose()
  isShipmentStartNotifiedList: string[];
  @Expose()
  isShipmentArrivedPickupLocationNotifiedList: string[];
  @Expose()
  isShipmentLoadedNotifiedList: string[];
  @Expose()
  isShipmentArrivedDeliveryLocationNotifiedList: string[];
  @Expose()
  isShipmentDeliveredNotifiedList: string[];

  @Expose()
  users: Partial<User>[];

  @Expose()
  overdueNotifyEnabled: boolean;

  @Expose()
  overdueReminderEnabled: boolean;

  @Expose()
  overdueReminderTimeframe: InvoiceReminderTimeframe;

  @Expose()
  overdueReminderInterval: number;

  @Expose()
  overdueReminderWeekdays: number[];

  @Expose()
  overdueReminderDayOfMonth: number;

  @Expose()
  overdueBcc: string[];
}
